import { XeroAddressModel } from "@/models/XeroAddressModel";
import { XeroPhoneModel } from "@/models/XeroPhoneModel";
import { CurrencyCode, XeroContactStatus } from "@/common/enum";
import Shared from "@/common/shared";

export class XeroContactModel {
  public name!: string;
  public firstName!: string;
  public lastName!: string;
  public emailAddress!: string;
  public defaultCurrency!: CurrencyCode;
  public contactID!: string;
  public taxNumber!: string;
  public addresses!: XeroAddressModel[];
  public phones!: XeroPhoneModel[];
  public contactStatus!: XeroContactStatus;

  constructor() {
    this.addresses = [new XeroAddressModel()];
    this.phones = [new XeroPhoneModel()];
    this.contactStatus = XeroContactStatus.ACTIVE;
    this.defaultCurrency = Shared.defaultCurrency;
  }
}
